module.exports = __webpack_public_path__ + "static/media/logoutIcon.d0ff8c12.svg";